import { type AppNode } from '../types';

/**
 * Minimal dependency-injection seam so localization utilities can read and update
 * canvas nodes without importing the edit-canvas store directly (which would create
 * a circular import: store.ts binds this bridge at module load).
 */
type EditCanvasBridge = {
  getNodes: () => AppNode[];
  removeNodes: (nodeIds: string[]) => void;
  /** Returns the canvas to its default mode, exiting any active image transform. */
  resetCanvasMode: () => void;
  updateNodeData: (nodeId: string, data: Record<string, unknown>) => void;
};

let editCanvasBridge: EditCanvasBridge | null = null;

export const bindEditCanvasBridge = (bridge: EditCanvasBridge): void => {
  editCanvasBridge = bridge;
};

export const getEditCanvasBridge = (): EditCanvasBridge => {
  if (!editCanvasBridge) {
    throw new Error('Edit canvas bridge is not initialized');
  }

  return editCanvasBridge;
};
